
<div class="content-wrapper d-print-none">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">ManPower Requests</h4>
            <div style="background: #ECECEC;padding:30px;">
                <div nz-row [nzGutter]="8">
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Location">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedLocationId" name="selectedDepartmentId"
                              id="selectedDepartmentId"   (change)="onLocationChange($event)">
                              <option value="">-- Select Location --</option>
                              <option [value]="location.name" *ngFor="let location of Locations">{{location.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>

                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Function">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedFunctionId" name="selectedLocationId"
                              id="selectedLocationId"   (change)="onFunctionChange($event)">
                              <option value="">-- Select Function --</option>
                              <option [value]="department.name" *ngFor="let department of Departments">{{department.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>

                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Type Of Vacancy">
                           <!-- Department  -->
                    
                              <ng-select [(ngModel)]="typeOfVacancy" (ngModelChange)="onTypeOfVacancyChange($event)" id="typeOfVacancy" name="typeOfVacancy">
                                <ng-option *ngFor="let a of typeofvacancy"  [value]="a.vacancy">{{a.vacancy}}
                                  </ng-option>
                              </ng-select>
                           
                    </nz-card>
                  </div>

               
                </div>

                <div nz-row [nzGutter]="8">
              
                
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Current Function">
                        <div class="col">
                              <select class="form-control" (ngModelChange)="onModeOfRecruitmentChange($event)" required [(ngModel)]="modeOfRecruitment" name="modeofrecruitment"
                                id="modeofrecruitment">
                                <option value="">-- Select Mode  of Recruitment --</option>
                                <option [value]="d.modeofrecruitments"  *ngFor="let d of ModeOfrecRuitment">{{d.modeofrecruitments}}
                                </option>
                              </select>
                            </div>
                       
                    </nz-card>
                  </div>
                 
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Created Date">
                      <nz-range-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-range-picker>
                      <br>
                      <br> 
                      
                        <button type="button" class="btn btn-primary btn-sm" (click)="GetByDate()">Submit</button>
                    
                   
                    </nz-card>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Status">
                          <!-- Statuses  -->
                          <select class="form-control" required [(ngModel)]="selectedStatus" name="selectedStatus"
                          id="selectedStatus"   (change)="onStatusChange($event)">
                          <option value="">-- Select Status --</option>
                          <option [value]="status.value" *ngFor="let status of Statuses">{{status.name}}
                          </option>
                        </select>
                    </nz-card>
                  </div>
                
                </div>
              </div>

              <div class="table-responsive pt-3">

                <input type="button" value="Export To Excel" (click)="exportExcel()" class="btn-primary"/>
             
                <nz-table #ManPowerTable [nzData]="Requests" [nzPageSize]="50">
                  <thead>
    
                    <tr>
                      <th>
                        #
                      </th>
    
                      <th>
                        Request Date
                      </th>
    
                      <th>
                        Created By
                      </th>
    
                      <th>
                        Function
                      </th>
    
                      <th>
                        Location
                      </th>
    
                      <th>
                        Status
                      </th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of ManPowerTable.data; let i = index ;" (click)="open(data)" class="clickable" >
    
                      <td>
                        {{i+1}}
                      </td>
                      <td>
                        {{ data.createdDate | date: 'dd MMMM yyy' }}
                      </td>
    
                      <td>
                        {{data.createdBy}}
                      </td>
    
                      <td>
                        {{data.requesterFunction}}
                      </td>

                      <td>
                        {{data?.location}}
                      </td>
    
                      <td>
                        <button [ngClass]="getStatusColor(data.status)"> {{data.status}}</button>
                      </td>
                      <td>
                    
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
    
              </div>

              
          </div>
        </div>
      </div>
  
  
    </div>
  </div>

  

<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040" [nzVisible]="ViewManpowerRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block" id="detailSection">
      <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
              <div class="row">
                  <div class="col">
                      <h5 class="card-title"> Manpower Request Details</h5>
                  </div>
                  <div class="col">
                      <img src="../../../assets/images/holcim_logo_color.svg" alt="" srcset="" style="height: 30px;">
                  </div>
              </div>


              <div class="card-body">




                  <h5>REQUESTOR DETAILS</h5>
                  <br>
                  <div class="row">

                      <div class="col">
                          <label><b>Request Reference</b></label>
                          <p>{{ UpdateRequest?.reference }}</p>
                      </div>
                      <div class="col">
                          <label><b>Requester Name</b></label>
                          <p>{{ UpdateRequest?.requesterName }}</p>
                      </div>
                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Requester Function</b></label>
                          <p>{{ UpdateRequest?.requesterFunction }}</p>
                      </div>
                      <div class="col">
                          <label><b>Requester Unit</b></label>
                          <p>{{ UpdateRequest?.requesterUnit }}</p>
                      </div>
                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Requester Designation</b></label>
                          <p>{{ UpdateRequest?.requesterDesignation }}</p>
                      </div>
                      <div class="col">
                          <label><b>Request Date</b></label>
                          <p>{{ UpdateRequest?.requestDate | date: 'dd MMMM yyyy' }}</p>
                      </div>
                  </div>
                  <div class="row">

                      <div class="col">
                          <label><b>Reason For Vacancy</b></label>
                          <p>{{ UpdateRequest?.reasonForVacancy }}</p>
                      </div>
                      <div class="col">
                          <label><b>Job Title</b></label>
                          <p>{{ UpdateRequest?.jobTitle }}</p>
                      </div>

                  </div>
              </div>

              <!-- <hr *ngIf="!editing"> -->

              <!-- Non Editable View -->
              <!-- <div class="card-body" *ngIf="!editing">
        <div class="row">

          <div class="col">
            <label><b>Request Date</b></label>
            <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
          </div>

          <div class="col">
            <label><b>Contract Duration (Month)</b></label>
            <p>{{ UpdateRequest?.contractDuration }}</p>
          </div>
        </div>

        <div class="row">

          <div class="col">
            <label><b>Expected Start Date</b></label>
            <p>{{ UpdateRequest?.expectedStartDate | date: 'dd MMMM yyyy' }}</p>
          </div>

          <div class="col">
            <label><b>Number of Staff</b></label>
            <p>{{ UpdateRequest?.noOfStaff }}</p>
          </div>
        </div>

        <div class="row">

          <div class="col">
            <label><b>Medical Notes </b></label>
            <p>{{ UpdateRequest?.medicalNotes  }}</p>
          </div>

          <div class="col">
            <label><b> Active Number of Employees</b></label>
            <p>{{ UpdateRequest?.numberofActiveEmployees }}</p>
          </div>
        </div>


        <div class="row">

          <div class="col">
            <label><b>Budget Cost</b></label>
            <p>{{ UpdateRequest?.budgetCost | currency:"NGN":"symbol-narrow" }}</p>
          </div>

          <div class="col">
            <label><b>Requested By</b></label>
            <p>{{ UpdateRequest?.createdBy }}</p>
          </div>
        </div>

       
       

        </div> -->
              <div class="card-body">
                  <div class="row">

                      <div class="col">
                          <label><b>N + 1 Designation</b></label>
                          <p>{{ UpdateRequest?.nPlus1Designation }}</p>
                      </div>

                      <div class="col">
                          <label><b>Band</b></label>
                          <p>{{ UpdateRequest?.band }}</p>
                      </div>

                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Cost Center</b></label>
                          <p>{{ UpdateRequest?.costCenter }}</p>
                      </div>
                      <div class="col">
                          <label><b>Location</b></label>
                          <p>{{ UpdateRequest?.location }}</p>
                      </div>


                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Date Vacancy Occured</b></label>
                          <p>{{ UpdateRequest?.dateVacancyOccurred | date: 'dd MMMM yyyy'}}</p>
                      </div>

                      <div class="col">
                          <label><b>Required Number</b></label>
                          <p>{{ UpdateRequest?.requiredNumber }}</p>
                      </div>
                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Type Of Vacancy</b></label>
                          <p>{{ UpdateRequest?.typeOfVacancy }}</p>
                      </div>
                      <div class="col">
                          <label><b>Reason For Vacancy</b></label>
                          <p>{{ UpdateRequest?.reasonForVacancy }}</p>
                      </div>



                  </div>
                  <div class="row">
                      <div class="col">
                          <label><b>Mode Of Recruitment</b></label>
                          <p>{{ UpdateRequest?.modeOfRecruitment }}</p>
                      </div>

                      <div class="col">
                          <label><b>Duration Of Contract</b></label>
                          <p>{{ UpdateRequest?.durationOfContract }}</p>
                      </div>

                  </div>

                  <div class="row">
                      <div class="col">
                          <label><b>Estimated Annual Cost</b></label>
                          <p>{{ UpdateRequest?.estimatedAnnualCost }}</p>
                      </div>

                      <div class="col">
                          <label><b>Justification For Vacancy</b></label>
                          <p>{{ UpdateRequest?.justificationForVacancy }}</p>
                      </div>

                  </div>
                  <div class="row">

                      <div class="col">
                          <label><b>Request Date</b></label>
                          <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
                      </div>

                      <div class="col">
                          <label><b>Educational Qualification</b></label>
                          <p>{{ UpdateRequest?.qualification }}</p>
                      </div>
                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Skills Required</b></label>
                          <p>{{ UpdateRequest?.skillsRequired }}</p>
                      </div>

                      <div class="col">
                          <label><b>Experience</b></label>
                          <p>{{ UpdateRequest?.experience }}</p>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col">
                          <label><b>Syetem Requirements</b></label>
                          <p>{{ UpdateRequest?.systemRequired }}</p>
                      </div>

                      <div class="col">
                          <label><b>Requested By</b></label>
                          <p>{{ UpdateRequest?.createdBy }}</p>
                      </div>

                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Other System Required</b></label>
                          <p>{{ UpdateRequest?.otherSystemRequirements }}</p>
                      </div>
                  </div>

                  <hr *ngIf="ViewlevelOfCompliance">
                  <div class="row" *ngIf="ViewlevelOfCompliance">
                      <div class="col">
                          <label><b>Approved Budget For The Department</b></label>
                          <p>{{ UpdateRequest?.presentDepartmentManpowerFigure }}</p>
                      </div>
                      <div class="col">

                          <label><b>Present Manpower Figure For The Department</b></label>
                          <p>{{ UpdateRequest?.presentDepartmentManpowerFigure }}</p>
                      </div>
                      <div class="col">
                          <label><b>Level of Risk Exposure(Compliance)</b></label>
                          <br>
                          <p [ngClass]="getColor(UpdateRequest?.levelOfExposureCompliance)">{{ UpdateRequest?.levelOfExposureCompliance }} </p>
                      </div>
                  </div>
<hr>
                  <div class="row">
                    <div class="col">
                      <div class="col pull right" >	
                        <button (click)="getJD(UpdateRequest)">Download Document</button>
                      </div>
                      
                    </div>
        
                    <div class="col">
                      <div class="col pull right" >	
                      <nz-space>
                         
                          <button *nzSpaceItem nz-button nzType="primary" (click)="showDocument(UpdateRequest)">View Document</button>
                        </nz-space>
                  </div>
                </div>
          
          </div>
          <div class="card-body" >
            <h5 class="card-title">Approvals</h5>
            <div class="table-responsive" >
              <table class="table table--striped table-hover">
                <thead>
                  <tr>
                    <th>
                      Designation Name
                    </th>
                    <th>
                      Approved By
                    </th>
                    <th>
                      Date Approved
                    </th>
                    <th>
                      Message
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let approval of ManPowerRequestApprovals">
                    <td>{{approval.designationName}}</td>
                    <td>{{approval.approvedBy}}</td>
                    <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
                    <td>{{approval.message}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
        
            <div *ngIf="!ManPowerRequestApprovals?.length"
              style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
              <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
            </div>
            <!-- Approvals -->
          </div>
      </div>
      <!-- Side swipe content -->

       <!-- Approvals -->
 
      <ng-template #footerTpl>
          <div style="float: right" class="d-print-none">
              <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;" (click)="close()">Close</button>
          </div>


      </ng-template>
  